const base64DecodeRootState = () => {
  try {
    if (window?.LD?.__state?.encoded) {
      return window.LD.__state.encoded
        ? JSON.parse(atob(window.LD.__state.encoded))
        : {}
    } else {
      return window?.LD?.__state || {}
    }
  } catch (error) {
    console.error('Unable to parse root state from window.LD', error)
    return {}
  }
}

export const rootState = base64DecodeRootState()

if (window.LD && window.LD.__state) {
  delete window.LD.__state
}
